module.exports = __webpack_public_path__ + "static/img/getallmoney.ae883fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/getallmoney.png
// module id = Bkq5
// module chunks = 2